//LEVEL ONE CONSTANTS
export const __CE_COMPELLING_EVIDENCE__ = 'CE';
export const __ID_INVALID_DISUTE__ = 'ID';
export const __ND_CARDHOLDER_NO_LONGER_DISPUTES__ = 'ND';
export const __DC_DELAYED_CHARGE_TRANSACTION__ = 'DC';
export const __CNLD_CARDHOLDER_NO_LONGER_DISPUTES__ = 'CNLD';
export const __CP_CREDIT_OR_REVERSAL_PROCESSED__ = 'CP';
export const __EVIDENCE_OF_IMPRINT__ = 'MI';
export const __RM_REVERSAL_ISSUED_BY_MERCHANT__ = 'RM';
export const __NL_NOT_LISTED_ABOVE__ = 'NL';
export const __CDLT__ = 'CDLT';
export const __FC__ = 'FC';

//COMPONENT LEVEL CONSTANTS
export const __POP__ = 'pop';
export const __PUSH__ = 'push';
export const __DROP_DOWN__ = 'DROPDOWN';
export const __ATTACH_DOCUMENT__ = 'attachDoc';
export const __INDEX_ZERO__ = 0;
export const __ALLOCATION__ = 'Allocation';
export const __ALOC__ = 'ALOC';
export const __COLLABORATION__ = 'Collaboration';
export const __COLB__ = 'COLB';

//LEVEL TWO CONSTANTS
export const __IDRA4__ = 'IDRA4';
export const __CP01__ = 'CP01';
export const __IDRA1__ = 'IDRA1';
export const __IDRA2__ = 'IDRA2';
export const __IDRA3__ = 'IDRA3';
export const __CP02__ = 'CP02';
export const __IDRA5__ = 'IDRA5';
export const __IDRA6__ = 'IDRA6';
export const __IDRA7__ = 'IDRA7';
export const __CE03__ = 'CE03';
export const __CE04__ = 'CE04';
export const __CE09__ = 'CE09';
export const __CE13__ = 'CE13';
export const __IDRC3__ = 'IDRC3';
export const __IDRC25__ = 'IDRC25';
export const __CE17__ = 'CE17';
export const __CE18__ = 'CE18';
export const __CE16__ = 'CE16';


//COLUMNKEY CONSTANTS
export const __idCollaborationCheckbox__ = 'idCollaborationCheckbox';
export const __ace04DescDownloaded__ = 'ace04DescDownloaded';
export const __ace04DownloadDate__ = 'ace04DownloadDate';
export const __ace04DownloadTime__ = 'ace04DownloadTime';
export const __ace04ProofWebAccess__ = 'ace04ProofWebAccess';
export const __ace04DescProof__ = 'ace04DescProof';
export const __ace04EvidenceWebAccess__ = 'ace04EvidenceWebAccess';
export const __ace04DescEvid__ = 'ace04DescEvid';
export const __ace04EvidenceSameDevice__ = 'ace04EvidenceSameDevice';
export const __ace04ARN__ = 'ace04ARN';
export const __ace04TransacAmount__ = 'ace04TransacAmount';
export const __ace04TranDate__ = 'ace04TranDate';
export const __ace04PurchaserIp__ = 'ace04PurchaserIp';
export const __ace04GeoLocation__ = 'ace04GeoLocation';
export const __ace04GeoPurcheserIP__ = 'ace04GeoPurcheserIP';
export const __ace04PurchaserName__ = 'ace04PurchaserName';
export const __ace04PurchasrEmail__ = 'ace04PurchasrEmail';
export const __ace04PurchasrName__ = 'ace04PurchasrName';
export const __ace04DeviceIDName__ = 'ace04DeviceIDName';
export const __ace04DevId__ = 'ace04DevId';
export const __ace04DeviceName__ = 'ace04DeviceName';
export const __ace09EvidenceSameDevice__ = 'ace09EvidenceSameDevice';

export const __cce04DescDownloaded__ = 'cce04DescDownloaded';
export const __cce04DownloadDate__ = 'cce04DownloadDate';
export const __cce04DownloadTime__ = 'cce04DownloadTime';
export const __cce04ProofWebAccess__ = 'cce04ProofWebAccess';
export const __cce04DescProof__ = 'cce04DescProof';
export const __cce04EvidenceWebAccess__ = 'cce04EvidenceWebAccess';
export const __cce04DescEvid__ = 'cce04DescEvid';
export const __cce04EvidenceSameDevice__ = 'cce04EvidenceSameDevice';
export const __cce04ARN__ = 'cce04ARN';
export const __cce04TransacAmount__ = 'cce04TransacAmount';
export const __cce04TranDate__ = 'cce04TranDate';
export const __cce04PurchaserIp__ = 'cce04PurchaserIp';
export const __cce04GeoLocation__ = 'cce04GeoLocation';
export const __cce04GeoPurcheserIP__ = 'cce04GeoPurcheserIP';
export const __cce04PurchaserName__ = 'cce04PurchaserName';
export const __cce04PurchasrEmail__ = 'cce04PurchasrEmail';
export const __cce04PurchasrName__ = 'cce04PurchasrName';
export const __cce04DeviceIDName__ = 'cce04DeviceIDName';
export const __cce04DevId__ = 'cce04DevId';
export const __cce04DeviceName__ = 'cce04DeviceName';
export const __ce04EvidenceSameDeviceCheckBox__ = 'ce04EvidenceSameDeviceCheckBox';
export const __colbAuthorizationDate__ = 'colbAuthorizationDate';
export const __colbTransactionDate__ = 'colbTransactionDate';
export const __colbCancellationDate__ = 'colbCancellationDate';
export const __INVALID_DISPUTE_REASON__ = 'invalidDisputeReason';

//REASON CODES
//REASON CODES - ALOC
export const __REASON_CODE_101__ = '10.1';
export const __REASON_CODE_102__ = '10.2';
export const __REASON_CODE_103__ = '10.3';
export const __REASON_CODE_104__ = '10.4';
export const __REASON_CODE_105__ = '10.5';
export const __REASON_CODE_111__ = '11.1';
export const __REASON_CODE_112__ = '11.2';
export const __REASON_CODE_113__ = '11.3';

//REASON CODES - COLB
export const __REASON_CODE_121__ = '12.1';
export const __REASON_CODE_122__ = '12.2';
export const __REASON_CODE_123__ = '12.3';
export const __REASON_CODE_124__ = '12.4';
export const __REASON_CODE_125__ = '12.5';
export const __REASON_CODE_126__ = '12.6';
export const __REASON_CODE_1261__ = '12.6.1';
export const __REASON_CODE_1262__ = '12.6.2';
export const __REASON_CODE_127__ = '12.7';
export const __REASON_CODE_131__ = '13.1';
export const __REASON_CODE_132__ = '13.2';
export const __REASON_CODE_133__ = '13.3';
export const __REASON_CODE_134__ = '13.4';
export const __REASON_CODE_135__ = '13.5';
export const __REASON_CODE_136__ = '13.6';
export const __REASON_CODE_137__ = '13.7';
export const __REASON_CODE_138__ = '13.8';
export const __REASON_CODE_139__ = '13.9';

export const __SINGLEDATE__ = 'SINGLEDATE';
export const __SINGLECRCTTRSNDATE__ = 'SINGLECRCTTRSNDATE';
export const __DROPDOWN__ = 'DROPDOWN';